import React, { useState, useEffect } from 'react'
import styles from './GeoHeader.module.scss'
import getVectorImage from '../../../utils/getVectorImage'
import { useGeoFetch, useGeoState } from '../../../components/GeoProvider'
import dayjs from 'dayjs'
import typeDisplayOptions from '../../Dashboard/typeDisplayOptions'
import SelectList from '../../../components/SelectMenuList'
import DefaultBreadcrumbs from '../../../components/Breadcrumbs/DefaultBreadcrumbs'
import Search from '../../../components/Search'
import { lastweekEndDate } from './../dates'

const HeaderDisplay = ({ headerType, geo_id }) => {
  //const lastweekEndDate = dayjs().day(-1).format('YYYY-MM-DD')
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [getgeoid, setgeoid] = useState('')
  const [getistrue, setistrue] = useState('')
  const [getDatavalue, setDatavalue] = useState('')
  const [getstatename, setStatename] = useState('')

  const [getPercentage, setPercentage] = useState('')
  const { setLocationName } = useGeoState()
  const { data: headerdata, error: stateDataError } = useGeoFetch(
    lastweekEndDate,
    lastweekEndDate,
    'rsvHeader',
    geo_id
  )

  useEffect(() => {
    if (headerdata !== null && headerdata !== undefined) {
      if (headerdata.response_code === 200) {
        setgeoid(headerdata.response_data.geo_id)
        setistrue(headerdata.response_data.istrue)
        setPercentage(headerdata.response_data.percentage)
        setDatavalue(headerdata.response_data.datavalue)
        setStatename(headerdata.response_data.statename)
        headerType === 'msa' &&
          setLocationName(headerdata.response_data.statename)
      } else {
        setErrorSubject(headerdata.response_subject)
        seterrorOccured(true)
      }
    }
  }, [headerdata])

  if (stateDataError || (errorOccured && errorSubject !== undefined)) {
    return <div>Unable to get the data for header {errorSubject}</div>
  }

  return (
    <>
      <div
        className={
          headerType === 'nat'
            ? styles.natDiv
            : headerType === 'state'
            ? styles.stateDiv
            : styles.geoDiv
        }
      >
        <span className={styles.firstSpan}>
          {headerType !== 'state' && headerType !== 'nat'
            ? getstatename
            : getgeoid}
        </span>
        <span className={styles.secondSpan}>{getVectorImage(getistrue)}</span>
        <span
          className={getistrue ? styles.stdatavalueup : styles.datavaluedown}
        >
          {' '}
          {getPercentage}%{' '}
        </span>
        <span className={styles.forthSpan}>
          {' '}
          ({getDatavalue})
          {headerType !== 'nat' && headerType !== 'state' ? (
            <span className={styles.sinceWeek}> since last week</span>
          ) : (
            ''
          )}
        </span>
      </div>
    </>
  )
}

const Header = ({ headerType, headerNumber, geo_id }) => {
  const [searchCriteria, setSearchCriteria] = React.useState([])
  const [activeCbsa, setActiveCbsa] = useState()
  const { locationName } = useGeoState()
  const { data: activeCbsasData, error: activeCbsasDataError } = useGeoFetch(
    '',
    '',
    'search',
    'locations/RSV?geo_type=MSA'
  )

  useEffect(() => {
    if (activeCbsasData !== null && activeCbsasData !== undefined) {
      setActiveCbsa(activeCbsasData)
    }
  }, [activeCbsasData])
  return (
    <>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderText}>
          <DefaultBreadcrumbs
            geo_parent={headerType}
            geo_id={geo_id}
            geo_type={'msa'}
            dashboardType={'rsv'}
          />
          <SelectList
            dropdownData={typeDisplayOptions}
            defaultValue={'rsv'}
            defaultLabel={'RSV Incidence'}
          />
        </div>
        <div className={styles.geoName}>{locationName}</div>
        <div className={styles.pageHeaderRight}>
          <div className={styles.pageHeaderTextValue}>
            <HeaderDisplay headerType={'nat'} geo_id={'nat'}></HeaderDisplay>
            <HeaderDisplay
              headerType={'state'}
              geo_id={headerType}
            ></HeaderDisplay>
            <HeaderDisplay headerType={'msa'} geo_id={geo_id}></HeaderDisplay>
          </div>
          <div className={styles.pageHeaderSearch}>
            {activeCbsa && (
              <Search
                criteria={searchCriteria}
                onChange={setSearchCriteria}
                entity={'rsv'}
                activeMetros={activeCbsa}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}
export default Header
